import { Link } from 'react-router-dom';
import classes from '../Hero.module.css';

const ScrollToContinue = () => (
  <div className={classes.messageContainer}>
    <span className={classes.continue}>scroll to continue</span>
    <Link to="/#home">
      <img className={classes.arrowIcon} alt="arrow" src="/images/arrow.svg" />
    </Link>
  </div>
);

export default ScrollToContinue;
